import { useState, useEffect, useCallback } from "react";
import { getInvoiceTrends } from "../services/analyticsService";

/**
 * Fetches monthly spending trend from invoices (sum by invoice_date month).
 * @param {string|number} tenantId
 * @param {number} months
 * @returns {Object} { data: { trends }, loading, error, refresh }
 */
export const useInvoiceTrends = (tenantId, months = 12) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!tenantId) {
      setData(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await getInvoiceTrends(tenantId, months);

      if (response?.success && response?.data) {
        setData(response.data);
      } else {
        setData(null);
        setError(new Error("Failed to load invoice trends"));
      }
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [tenantId, months]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
};
